import { useRouter } from '@application/utils';
import { Container, MtOnBoardingCard } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { TbArrowRampRight2, TbCalendarEvent, TbDog, TbGift, TbList } from 'react-icons/tb';
import * as Styled from './styled';
import type { MtLandingBuyerProps } from './types';

export * from './types';

export const MtLandingBuyerPage: FC<MtLandingBuyerProps> = () => {
  const { navigateToRoute } = useRouter();
  const { translate } = useTranslation();
  const { translate: translateResource } = useTranslation({ keyPrefix: 'mt.buyer.landing' });

  return (
    <Container>
      <Styled.Title>
        <TbArrowRampRight2 /> {translateResource('title')}
      </Styled.Title>

      <Styled.CardsWrapper>
        <MtOnBoardingCard
          title={translateResource('cards.applications.title')}
          text={translateResource('cards.applications.text')}
          icon={<TbList />}
          btnText={translate('common.buttons.open')}
          btnOnClick={() => navigateToRoute('mtApplications')}
        />
        <MtOnBoardingCard
          title={translateResource('cards.appointments.title')}
          text={translateResource('cards.appointments.text')}
          icon={<TbCalendarEvent />}
          btnText={translate('common.buttons.open')}
          btnOnClick={() => navigateToRoute('mtAppointments')}
        />
        <MtOnBoardingCard
          title={translateResource('cards.animals.title')}
          text={translateResource('cards.animals.text')}
          icon={<TbDog />}
          btnText={translate('common.buttons.open')}
          btnOnClick={() => navigateToRoute('mtAnimals')}
        />
        <MtOnBoardingCard
          title={translateResource('cards.guide.title')}
          text={translateResource('cards.guide.text')}
          icon={<TbGift />}
          btnText={translate('common.buttons.open')}
          btnOnClick={() => navigateToRoute('mtPuppyGuide')}
        />
      </Styled.CardsWrapper>
    </Container>
  );
};
